import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { GET_USEFUL_PHRASES, GET_USEFUL_PHRASES_MSB } from '@/graphql/Mystage/usefulPhrases';
import { bizmatesApi } from '@/utils/bizmatesApi';
import logger from '@/modules/Logger';

/**
 * GetUsefulPhrasesService
 */
export const GetUsefulPhrasesService = {
  // Method to fetch useful phrases list from new GraphQL endpoint
  msb: async (lessonId, jwtKeyValue, isTrial, callback) => {
      logger.debug(`[UsefulPhrases][Get] Get list of useful phrases using MSB GraphQL enpoint`, {
        operation: 'usefulphrases:load-list'
      });

      const client = myStageApolloProvider.defaultClient;
      const { data } = await client.query({
        fetchPolicy: 'no-cache',
        query: GET_USEFUL_PHRASES_MSB,
        variables: {
          lesson_id: parseInt(lessonId),
        }
      });
      
      if (data?.usefulPhrases) {
        callback(data.usefulPhrases);
      } else {
        logger.error(
            `[UsefulPhrases][Get] [Lesson No ${lessonId}] Empty result from materials api`,
            { operation: 'usefulphrases:load-list', event_type:4, lesson_id:lessonId }
          );
      }
  },

  mbti: async (lessonId, jwtKeyValue, isTrial, callback) => {
      logger.debug(`[UsefulPhrases][Get] Get list of useful phrases using MBTI GraphQL enpoint`, {
        operation: 'usefulphrases:load-list'
      });

      const client = apolloProvider.defaultClient;
      const { data } = await client.query({
        fetchPolicy: 'no-cache',
        query: GET_USEFUL_PHRASES,
        variables: {
          lesson_id: parseInt(lessonId),
        }
      });
      
      if (data?.useful_phrases) {
        callback(data.useful_phrases);
      } else {
        logger.error(
            `[UsefulPhrases][Get] [Lesson No ${lessonId}] Empty result from materials api`,
            { operation: 'usefulphrases:load-list', event_type:4, lesson_id:lessonId }
          );
      }
  },

  // Method to fetch useful phrases list from legacy REST API endpoint
  legacy: async (lessonId, jwtKeyValue, isTrial, callback) => {
    logger.debug(`[UsefulPhrases][Get] Get list of useful phrases using legacy api`, {
      operation: 'usefulphrases:load-list'
    });

    const path = `usefulphrases/list?b=${lessonId}`;

    await bizmatesApi.get(path, { params: {} }, response => {
      if (response.data && response.data?.items.length) {
        callback(response.data.items);
      } else {
        logger.error(
          `[UsefulPhrases][Get] [Lesson No ${lessonId}] Empty result from materials api`,
          { operation: 'usefulphrases:load-list', event_type: 4, lesson_id: lessonId }
        );
      }
    });
  }
};
